import axios from "axios"
import tracker from "./tracker"
import { TRACK_EVENTS } from "./constants"
import { HTTP_RESPONSE } from "../components/consts"

let isUpdateWhitelistSuccessfullySent = false

const settingsInstance = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: ajax_obj.ajax_url,
})

const trackUpdateKeysEvent = (status, settings) => {
  if(status !== HTTP_RESPONSE.OK)
    tracker.track(TRACK_EVENTS.AUTHENTICATION_MISMATCH, settings)
  else if(settings.deactivate)
    tracker.track(TRACK_EVENTS.DEACTIVATED, settings)
  else
    tracker.track(TRACK_EVENTS.ACTIVATED, settings)
}

class FormService {  
  async getSettings() {
    const form_data = new FormData()
    form_data.append("action", "get_settings")
    // eslint-disable-next-line no-undef
    form_data.append("nonce", ajax_obj.get_settings_nonce)
   return await settingsInstance.post("", form_data)   
  }
  async updateWhitelist(whitelist) {
    const form_data = new FormData()
    form_data.append("action", "update_whitelist")
    form_data.append("whitelist", whitelist)
        // eslint-disable-next-line no-undef
    form_data.append("nonce", ajax_obj.update_whitelist_nonce)

    // eslint-disable-next-line no-undef
    try {
      const response = await settingsInstance.post("", form_data)
      if (response?.data?.status !== HTTP_RESPONSE.OK) {
        return response.data.message
      }
      if(!isUpdateWhitelistSuccessfullySent){
        isUpdateWhitelistSuccessfullySent = true
        tracker.track(TRACK_EVENTS.WHITELIST_UPDATED, whitelist)
      }
    } catch (error) {
      return error?.response?.data?.message
    }  
  }
  async updateKeys(settings) {
    let res = ""
    const form_data = new FormData()
    form_data.append("action", "save_settings")
    // eslint-disable-next-line no-undef
    form_data.append("nonce", ajax_obj.save_settings_nonce)
    form_data.append("authKey", settings.authKey)
    form_data.append("secretKey", settings.secretKey)
    form_data.append("domainKey", settings.domainKey)
    form_data.append("deactivate", settings.deactivate)
    try {
      const response = await settingsInstance.post("", form_data)
      const responseStatus = response?.data?.status
      if (responseStatus !== HTTP_RESPONSE.OK) {
        res = response.data.message        
      }
      tracker.init(response?.data?.clientId)
      trackUpdateKeysEvent(responseStatus, settings)        
    } catch (error) {
      res = error?.response?.data?.message
      tracker.track(TRACK_EVENTS.AUTHENTICATION_ERROR, settings)
    }
    return res
  }
  async updateInstallBotzapping(updateValue) {
    const form_data = new FormData()
    form_data.append("action", "updateInstallBotzapping")
    // eslint-disable-next-line no-undef
    form_data.append("nonce", ajax_obj.nonce)
    form_data.append("installBozapping", updateValue)
    return await settingsInstance.post("", form_data)
  }
  async updateInstallClickFraud(updateValue) {
    const form_data = new FormData()
    form_data.append("action", "updateInstallClickFraud")
    // eslint-disable-next-line no-undef
    form_data.append("nonce", ajax_obj.update_install_clickfraud_nonce)
    form_data.append("installClickFraud", updateValue)
    return await settingsInstance.post("", form_data)
  }
}

export default FormService
